import {first} from '@shared/helpers/array'

import {initDetailByAPI} from '@web/actions/detail'
import {DeliveryAttributeCode} from '@web/core/constants'
import {ProductType, Status} from '@web/slices/pickup/slice'
import makeSlice from '@web/slices/pickup/sliceMaker'

const pickupSlice = makeSlice({
    extraReducers(builder) {
        builder.addCase(initDetailByAPI.fulfilled, (state, {payload}) => {
            const {pickUp, productOrders, productBundleGroups} = payload.data
            const primaryProduct = first(productOrders)
            const primaryMerchant = first(Object.values(productBundleGroups))

            if (primaryProduct?.deliveryAttributeType !== DeliveryAttributeCode.PICKUP) {
                return
            }

            if (!pickUp) {
                return
            }

            state.merchantName = primaryMerchant?.merchantName ?? ''
            state.branchName = primaryProduct?.branch?.branchName
            state.status = pickUp.unreceivedCompleted ? Status.UNRECEIVED : Status.WAIT
            state.productType = pickUp.alcohol ? ProductType.ALCOHOL : ProductType.NORMAL
            state.receiver = {
                name: pickUp.receiverName ?? '',
                phoneNumber: pickUp.receiverTelNo ?? '',
                virtualPhoneNumber: pickUp.virtualPhoneNumber,
            }
            state.code = pickUp.qrCode
            state.location = {
                address: [pickUp.baseAddress, pickUp.detailAddress].filter(Boolean).join(' '),
                point: {
                    x: pickUp.longitude ?? '',
                    y: pickUp.latitude ?? '',
                },
                imageUrl: primaryMerchant?.merchantImageUrl ?? '',
                markerColor: pickUp.markerColor ?? state.location.markerColor,
            }
        })
    },
})

export default pickupSlice.reducer
